import { TDR } from 'tdr-common';

function resultMapEntries(resultMap: TDR.Availability.searchOutput['resultMap']) {
	if (!resultMap) {
		return [] as [string, TDR.Availability.searchResult][];
	}
	if (resultMap instanceof Map) {
		return [...resultMap.entries()];
	}
	return Object.entries(resultMap) as [string, TDR.Availability.searchResult][];
}

function hasFullOpenParametersUnset(unSet: readonly string[] | undefined) {
	const u = unSet ?? [];
	return u.includes('groupSize') && u.includes('date') && u.includes('time');
}

export function getOpenParametersEmptyStateTables(
	results: TDR.Availability.searchOutput | undefined,
	tables: TDR.Table[]
): TDR.Table[] {
	const matchingIds = resultMapEntries(results?.resultMap)
		.filter(([, entry]) => hasFullOpenParametersUnset(entry?.unSet))
		.map(([id]) => id);

	return tables
		.filter((t) => matchingIds.includes(t.id))
		.sort((a, b) => (a.displayOrder ?? 9999) - (b.displayOrder ?? 9999));
}
